/*!

=========================================================
* Argon Dashboard PRO React - v1.2.5
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Login from "pages/Auth/Login";
import Register from "pages/Auth/Register";
import AddChannelPartner from "pages/ChannelPartner/AddChannelPartner";
import ChannelListing from "pages/ChannelPartner/ChannelListing";
import Dashboard from "pages/Dashboards/Dashboard";
import SampleTable from "pages/SampleTable";
import AddTrainee from "pages/Trainee/AddTrainee";
import TraineeListing from "pages/Trainee/TraineeListing";
import AddInstructor from "pages/Instructors/AddInstructor";
import Instructors from "pages/Instructors/Instructors";
import VisitorsListing from "pages/Visitors/VisitorsListing";
import VisitDetails from "pages/Visitors/VisitDetails";
import AdminProfile from "pages/Profile/AdminProfile";
import Courses from "pages/Courses/Courses";
import AddCourse from "pages/Courses/AddCourse";
import CertificateDesigner from "pages/Certificate/Templates/CertificateDesigner";
import Templates from "pages/Certificate/Templates/Templates";
import IssuanceList from "pages/Certificate/Issuance/IssuanceList";
import IssuanceDetails from "pages/Certificate/Issuance/IssuanceDetails";
import ViewCertificate from "pages/Certificate/Templates/ViewCertificate";
import Signatures from "pages/Certificate/Signatures/Signatures";

import ChannelPartnerDetails from "pages/ChannelPartner/ChannelPartnerDetails";
import InstructorDetails from "pages/Instructors/InstructorDetails";
import AdminListing from "pages/AdminManagement/AdminListing";
import AddAdmin from "pages/AdminManagement/AddAdmin";
import CoursePreview from "pages/Courses/CoursePreview";
import Skills from "pages/Master/Skills";
import CourseDetail from "pages/Courses/CourseDetail";
import Category from "pages/Master/Category";
import PreRequiredDocument from "pages/Master/PreRequiredDocument";

import InvoicesListing from "pages/Invoices/InvoicesListing";
import InvoiceDetails from "pages/Invoices/InvoiceDetails";
import QuestionBank from "pages/QuestionBank/QuestionBank";
import QuestionBankList from "pages/QuestionBank/QuestionBankList";
import QuestionBankDetails from "pages/QuestionBank/QuestionBankDetails";
import AssessmentDetail from "pages/Courses/AssessmentDetails";
import TrainingCenters from "pages/Master/TrainingCenters";
import AddTrainingCenter from "pages/Master/AddTrainingCenter";
import TraineeDetails from "pages/Trainee/TraineeDetails";
import AddSignature from "pages/Certificate/Signatures/AddSignature";
import LetterForm from "pages/Letter/LetterForm";
import LetterListing from "pages/Letter/LetterListing";
import Questions from "pages/QuestionBank/Questions";
import AddBatch from "pages/BatchManagement/AddBatch";
import ReceiptListing from "pages/Receipt/ReceiptListing";
import BatchListing from "pages/BatchManagement/BatchListing";
const routes = [
  {
    show: false,
    path: "/dashboard",
    name: "Dashboards",
    icon: "ni ni-shop text-deep-blue",
    component: <Dashboard />,
    layout: "/admin",
    roles: ["ADMIN", "CHANNEL_PARTNER", "TRAINER"],
  },
  {
    show: false,
    path: "/login",
    name: "Login",
    icon: "ni ni-ungroup text-orange",
    component: <Login />,
    layout: "/auth",
  },
  {
    show: false,
    path: "/register",
    name: "Register",
    icon: "ni ni-ungroup text-orange",
    component: <Register />,
    layout: "/auth",
  },
  {
    show: false,
    path: "/table",
    name: "Sample Table",
    icon: "ni ni-ungroup text-orange",
    component: <SampleTable />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: true,
    path: "/course",
    name: "Courses",
    icon: "ni ni-hat-3 text-deep-blue",
    component: <Courses />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/course/add-course",
    name: "Add Course",
    icon: "ni ni-shop text-primary",
    component: <AddCourse />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/course/add-course/preview",
    name: "Course Preview",
    icon: "ni ni-shop text-deep-blue",
    component: <CoursePreview />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/course/:id/details",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <CourseDetail />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/course/:id/details/:assessmentId",
    name: "Course Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <AssessmentDetail />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: true,
    path: "/batch",
    name: "Batches",
    icon: "fa-solid fa-solid fa-calendar-days text-deep-blue pr-4",
    component: <BatchListing />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/batch/add-batch",
    name: "Add Batch",
    icon: "fa-solid fa-chalkboard-user text-deep-blue pr-4",
    component: <AddBatch />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/batch/edit/:id",
    name: "Add Batch",
    icon: "fa-solid fa-chalkboard-user text-deep-blue pr-4",
    component: <AddBatch />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: true,
    path: "/instructor",
    name: "Trainers",
    icon: "fa-solid fa-chalkboard-user text-deep-blue pr-4",
    component: <Instructors />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/instructor/add-new",
    name: "Add Instructors",
    icon: "ni ni-shop text-deep-blue",
    component: <AddInstructor />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/instructor/:id/details",
    name: "Instructor Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <InstructorDetails />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: true,
    path: "/trainee",
    name: "Trainees",
    icon: "fa-solid fa-user-graduate pr-3 text-deep-blue",
    component: <TraineeListing />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/trainee/:id/details",
    name: "Trainee Detail",
    icon: "ni ni-shop text-deep-blue",
    component: <TraineeDetails />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/trainee/add-trainee",
    name: "Add-Trainee",
    icon: "ni ni-single-02 text-deep-blue",
    component: <AddTrainee />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/trainee/edit/:id",
    name: "Add-Trainee",
    icon: "ni ni-single-02 text-deep-blue",
    component: <AddTrainee />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/trainee/:id/details",
    name: "Trainee Details",
    icon: "ni ni-single-02 text-deep-blue",
    component: <TraineeDetails />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: true,
    path: "/channel-partner",
    name: "Channel Partners",
    icon: "fa-solid fa-user-tie pr-3 text-deep-blue",
    component: <ChannelListing />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/channel-partner/:id/details",
    name: "Channel Partner",
    icon: "ni ni-single-02 text-deep-blue",
    component: <ChannelPartnerDetails />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/channel-partner/add-new",
    name: "Channel Partner",
    icon: "",
    component: <AddChannelPartner />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/channel-partner/edit/:id",
    name: "Channel Partner",
    icon: "",
    component: <AddChannelPartner />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: true,
    path: "/list",
    name: "Admin",
    icon: "fa-solid fa-user pr-3 text-deep-blue",
    component: <AdminListing />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/list/add-new",
    name: "Admin Management",
    icon: "ni ni-single-02 text-deep-blue",
    component: <AddAdmin />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/profile",
    name: "Admin Profile",
    icon: "ni ni-ungroup text-orange",
    component: <AdminProfile />,
    layout: "/admin",
    roles: ["ADMIN"],
  },

  {
    show: false,
    path: "/certificate/create-certificate",
    name: "Create Certificate",
    icon: "ni ni-badge text-primary",
    component: <CertificateDesigner />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/certificate/view",
    name: "View Certificate",
    icon: "ni ni-badge text-primary",
    component: <ViewCertificate />,
    layout: "/admin",
    roles: ["ADMIN"],
  },

  {
    show: true,
    path: "/visitors",
    name: "Visitors",
    icon: "ni ni-user-run text-deep-blue",
    component: <VisitorsListing />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/visitors/:id/details",
    name: "Visitors Details",
    icon: "",
    component: <VisitDetails />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  // {
  //   show: true,
  //   path: "/invoices",
  //   name: "Invoice ",
  //   icon: "ni ni-single-copy-04 text-deep-blue",
  //   component: <InvoicesListing />,
  //   layout: "/admin",
  //   roles: ["ADMIN"],
  // },
  // {
  //   show: false,
  //   path: "/invoices/:id/details",
  //   name: "Invoice Details",
  //   icon: "ni ni-single-copy-04 text-deep-blue",
  //   component: <InvoiceDetails />,
  //   layout: "/admin",
  //   roles: ["ADMIN"],
  // },
  {
    show: true,
    path: "/receipt",
    name: "Receipt ",
    icon: "ni ni-single-copy-04 text-deep-blue",
    component: <ReceiptListing />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: true,
    path: "/question-bank",
    name: "Question Bank",
    icon: "ni ni-collection text-deep-blue",
    component: <QuestionBankList />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/question-bank/add",
    name: "Question Bank",
    icon: "ni ni-collection text-deep-blue",
    component: <QuestionBank />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/question-bank/add/questions",
    name: "Question Bank",
    icon: "ni ni-collection text-deep-blue",
    component: <Questions />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/question-bank/:id",
    name: "Question Bank",
    icon: "ni ni-collection text-deep-blue",
    component: <QuestionBankDetails />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    collapse: true,
    name: "Certificate",
    icon: "ni ni-badge text-deep-blue",
    state: "certificateCollapse",
    show: true,
    roles: ["ADMIN"],
    views: [
      {
        show: true,
        path: "/certificate/templates",
        name: "Templates",
        miniName: "T",
        component: <Templates />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
      {
        show: true,
        path: "/certificate/issuance",
        name: "Issuance",
        miniName: "I",
        component: <IssuanceList />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
      {
        show: false,
        path: "/certificate/issuance/:id",
        name: "Issuance Details",
        miniName: "I",
        component: <IssuanceDetails />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
      {
        show: true,
        path: "/signatures",
        name: "Signatures",
        miniName: "S",
        component: <Signatures />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
      {
        show: false,
        path: "/signatures/add-new",
        name: "Signatures",
        miniName: "S",
        component: <AddSignature />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
    ],
  },
  {
    show: true,
    collapse: true,
    name: "Masters",
    icon: "ni ni-settings-gear-65 text-deep-blue",
    state: "dashboardsCollapse",
    roles: ["ADMIN"],
    views: [
      {
        show: true,
        path: "/skill",
        name: "Skills",
        miniName: "S",
        component: <Skills />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
      {
        show: true,
        path: "/category",
        name: "Course Category",
        miniName: "C",
        component: <Category />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
      {
        show: true,
        path: "/documents",
        name: "Prerequisites Documents",
        miniName: "D",
        component: <PreRequiredDocument />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
      {
        show: true,
        path: "/training-center",
        name: "Training Centers",
        miniName: "E",
        component: <TrainingCenters />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
      {
        show: false,
        path: "/training-center/add-center",
        name: "Add Center",
        miniName: "E",
        component: <AddTrainingCenter />,
        layout: "/admin",
        roles: ["ADMIN"],
      },
    ],
  },
  {
    show: true,
    path: "/letters",
    name: "Letters",
    icon: "ni ni-single-copy-04 text-deep-blue",
    component: <LetterListing />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/letters/create-letter",
    name: "Letter",
    icon: "ni ni-single-copy-04 text-deep-blue",
    component: <LetterForm />,
    layout: "/admin",
    roles: ["ADMIN"],
  },
  {
    show: false,
    path: "/letters/edit-letter/:id",
    name: "Letter",
    icon: "ni ni-single-copy-04 text-deep-blue",
    component: <LetterForm />,
    layout: "/admin",
    roles: ["ADMIN"],
  },

  // {
  //   collapse: true,
  //   name: "Examples",
  //   icon: "ni ni-ungroup text-orange",
  //   state: "examplesCollapse",
  //   views: [
  //     {
  //       path: "/login",
  //       name: "Login",
  //       miniName: "L",
  //       component: <Login />,
  //       layout: "/auth",
  //     },
  //     {
  //       path: "/register",
  //       name: "Register",
  //       miniName: "R",
  //       component: <Register />,
  //       layout: "/auth",
  //     },
  //   ],
  // },
];

export default routes;
